import { queryOptions, useQuery } from '@tanstack/react-query';
import { getExchangeMaintenance } from '@/services/api/exchange-maintenance';

// Short enough that a flip made by someone else shows up while this page is open
const REFETCH_INTERVAL_MS = 15_000;

export const EXCHANGE_MAINTENANCE_QUERY_KEY = ['exchange', 'maintenance'] as const;

export const exchangeMaintenanceQueryOptions = () =>
  queryOptions({
    queryKey: EXCHANGE_MAINTENANCE_QUERY_KEY,
    queryFn: getExchangeMaintenance,
    refetchInterval: REFETCH_INTERVAL_MS,
  });

export const useExchangeMaintenance = () => useQuery(exchangeMaintenanceQueryOptions());
